import { MENU_CONSTANTS } from "../../../utils/consts";
import { MenuSubitem } from "../MenuSubitem";
import { nothingFoundSpanClass } from "../styles.css";
import type { MenuItemProps } from "../types";

interface MenuContentProps {
  activeSearch: string;
  sideBarOpen: boolean;
  searchItemsFiltered: MenuItemProps[];
  bodyItems: MenuItemProps[];
  onSearchChange: (value: string) => void;
  renderMenuItem: (item: MenuItemProps, index: number) => React.ReactNode;
}

export const MenuContent = ({
  activeSearch,
  sideBarOpen,
  searchItemsFiltered,
  bodyItems,
  onSearchChange,
  renderMenuItem,
}: MenuContentProps) => {
  if (activeSearch && sideBarOpen) {
    return searchItemsFiltered.length > 0 ? (
      searchItemsFiltered.map((item, index) => (
        <MenuSubitem
          key={(item.path || "") + index}
          subitem={item}
          setSearch={onSearchChange}
        />
      ))
    ) : (
      <span className={nothingFoundSpanClass} style={{ textAlign: "center" }}>
        {MENU_CONSTANTS.SEARCH.NO_RESULTS}
      </span>
    );
  }

  return bodyItems.map(renderMenuItem);
};
